export default __webpack_public_path__ + "static/media/goodwipes.d370c9d7.webp";